import { render, staticRenderFns } from "./TiptapSettings.vue?vue&type=template&id=43ba5fda"
import script from "./TiptapSettings.vue?vue&type=script&lang=js"
export * from "./TiptapSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports